  (function() {
    window.CartPage = window.CartPage || new function() {
    //runs once per page load
    var self = this;
    
    self.updateCart = function() {
      $s.showLoadingOverlay();
      $s.getJson({url: '/?sections=cart_content', success: function(data){
        var section = document.querySelector('.cart-content');
        $s.updateDynamicContent(section, data['cart_content']);
        var summaryWrapper = document.querySelector('#cart .summary-column');
        if (section.querySelector('.cart-items')) {
          summaryWrapper.style.display = '';
        } else {
          summaryWrapper.style.display = 'none';
        }
        $s.globalEval(data['cart_content']);
        $s.hideLoadingOverlay();
      }});
    }

    self.updateItemsQuantity = function(items, quantity){
      var data = {updates: {}}
      items.forEach(function(item) {
        data.updates[item.dataset.key] = quantity;
      });
      postUpdate(data);
    }

    function postUpdate(data) {
      $s.showLoadingOverlay();
      $s.post({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: async function(cart) {var runResponse = await $s.AutoAddRemoveProducts.runAllRules(JSON.parse(cart), true);self.updateCart();
        },
        error: $s.addToCartFail
      });
    }

    self.cartCount = function() {
      var cart = document.getElementById('cart');
      var itemsCount = 0;
      cart.querySelectorAll('.cart-items .item .quantity-box input[type=number]').forEach(function(item){
        itemsCount += item.value/1;
      });
      var cartCountElement = document.querySelector('header .cart-count');
      if(cartCountElement) {
        cartCountElement.innerHTML = itemsCount>0?itemsCount:'';
        document.querySelectorAll('#cart .qty-checker').forEach(x=>x.innerHTML = itemsCount>0?itemsCount:'');
      }
    }
  
  };
  //runs every time #cart div is replaced
  var cart = document.getElementById('cart');
  window.CartPage.cartCount();

  cart.querySelectorAll('.remove').forEach(function(item) {
    item.addEventListener('click', function(e){
      e.preventDefault();
      CartPage.updateItemsQuantity([this.closest('.item')], 0);
    });
  });

  cart.querySelectorAll('.cart-items input[type=number]').forEach(function(item) {
    item.addEventListener('change', function(e){
      CartPage.updateItemsQuantity([this.closest('.item')], this.value);
    });
  });var checkInstructions = document.getElementById('chk-instructions');
  if (checkInstructions) {
    var checkInstructionsChange = function() {
      var note = document.getElementById('instructions-note');
      if (checkInstructions.checked) {
        note.style.display = 'block';
      } else {
        note.style.display = 'none';
        var textarea = note.querySelector('textarea');
        if (textarea.value != '') {
          textarea.value = '';
          $s.dispatchEvent(textarea, 'change');
        }
      }
    }
    checkInstructions.labels[0].addEventListener('keypress', function(event) {
      if (event.keyCode==13) {
        checkInstructions.click();
      }
    });
    checkInstructions.addEventListener('click', checkInstructionsChange);
    checkInstructionsChange();
  }function getGiftNote() {
    var giftNote = 'To: ' + document.getElementById('gift-to').value + '\n' + 'From: ' + document.getElementById('gift-from').value + '\n' + 'Note: ' + document.getElementById('gift-message').value + '\n';
    return giftNote;
  }

  function validateLength(msgContainer, elements, maxLength) {
    var ok = true;
    if (elements.length > maxLength) {
      var removeQty = elements.length - maxLength;
      msgContainer.innerHTML = 'ERROR: '+maxLength+' character limit. Please remove '+ (removeQty==1 ? '1 character' : removeQty +' characters' ) +' to proceed.';
      ok = false;
      return false;
    }
    return ok;
  }

  function validateCharacters(msgContainer, elements) {
    var ok = true;
    var allowedCharacters = /^[0-9a-zA-Z \.\r\n]+$/;
    if (elements && !elements.match(allowedCharacters)) {
      ok = false;
    }
    if (!ok) {
      msgContainer.innerHTML = 'ERROR: Special characters not valid.';
      return false;
    }
    return true;
  }
  
  function blockSpecialChar(e) {
    var k = e.keyCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8   || (k >= 48 && k <= 57));
  }
  
  document.querySelectorAll('#gift-to, #gift-from, #gift-message').forEach((e) => {
    
    /*e.addEventListener('keypress', (k) => {
      blockSpecialChar(k);
    });*/

    e.addEventListener("change", function(evt) {
      var value = evt.target.value;
      var blockSpecialRegex = /[^a-zA-Z\d\s:]/g;
      evt.target.value = evt.target.value.replaceAll(blockSpecialRegex, "")
      var note = getGiftNote();
      $s.post({
        type: 'POST',
        url: '/cart/update.js',
        data: {"note": note},
        dataType: 'json',
        success: async function(cart) {
        }
      });
    });
  })

  if(typeof _swat == 'object') _swat.initializeActionButtons('#cart');
  })();